export default {
  fontSizes: {
    sm: `18px`,
    md: `22px`,
    lg: `30px`,
    xl: `45px`,
    xxl: `75px`
  },
  borderRadius: '7px'
};
